export const THEODORE_GET_EMAIL_OTP = 'components/forgot-password/THEODORE_GET_EMAIL_OTP';
export const THEODORE_GET_EMAIL_OTP_SUCCESS = 'components/forgot-password/THEODORE_GET_EMAIL_OTP_SUCCESS';
export const THEODORE_GET_EMAIL_OTP_FAILURE = 'components/forgot-password/THEODORE_GET_EMAIL_OTP_FAILURE';

export const theodoreGetEmailOtp = (data) => {
    return {
        type: THEODORE_GET_EMAIL_OTP,
        data
    }
}
export const theodoreGetEmailOtpSuccess = (data) => {
    return {
        type: THEODORE_GET_EMAIL_OTP_SUCCESS,
        data
    }
}
export const theodoreGetEmailOtpFailure = (data) => {
    return {
        type: THEODORE_GET_EMAIL_OTP_FAILURE,
        data
    }
}

export const THEODORE_RESET_PASSWORD = 'components/forgot-password/THEODORE_RESET_PASSWORD';
export const THEODORE_RESET_PASSWORD_SUCCESS = 'components/forgot-password/THEODORE_RESET_PASSWORD_SUCCESS';
export const THEODORE_RESET_PASSWORD_FAILURE = 'components/forgot-password/THEODORE_RESET_PASSWORD_FAILURE';

export const theodoreResetPassword = (data) => {
    return {
        type: THEODORE_RESET_PASSWORD,
        data
    }
}
export const theodoreResetPasswordSuccess = (data) => {
    return {
        type: THEODORE_RESET_PASSWORD_SUCCESS,
        data
    }
}
export const theodoreResetPasswordFailure = (data) => {
    return {
        type: THEODORE_RESET_PASSWORD_FAILURE,
        data
    }
}